<template>
    <div class="list-box" ref="box">
        <div class="header" ref="header">
            <el-button type="primary" plain @click="isAppPackDialogShow = true">iOS打包</el-button>
        </div>
        <el-table :data="tableData" ref="table" class="table" v-loading="isLoading" :height="tableHeight">
            <el-table-column prop="appID" label="appID" width="100">
            </el-table-column>

            <el-table-column label="状态">
                <template #default="scope">
                    <span v-if="scope.row.status == 0">
                        已使用
                    </span>
                    <span v-if="scope.row.status == 1">
                        未使用
                    </span>
                    <span v-if="scope.row.status == 2">
                        删除
                    </span>
                    <span v-if="scope.row.status == 3">
                        禁止
                    </span>
                </template>
            </el-table-column>

            <el-table-column label="logo">
                <template #default="scope">
                    <el-image class="logo" :src="scope.row.logo.square"></el-image>
                </template>
            </el-table-column>

            <el-table-column label="UA">
                <template #default="scope">
                    <p>{{ scope.row.app_ids }}</p>
                </template>
            </el-table-column>

            <el-table-column label="名称/包名">
                <template #default="scope">
                    <div>{{ scope.row.name }}</div>
                    <div>{{ scope.row.pack_name }}</div>
                </template>
            </el-table-column>

            <el-table-column label="操作">
                <template #default="scope">
                    <el-button type="primary" @click="visualEdit(scope.row)" plain size="small">可视化编辑</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="footer" ref="footer">
            <el-pagination v-if="pagination" background :total="pagination.total" :current-page="pagination.curPage"
                :page-size="pagination.perPage" @current-change="handleCurrentChange" layout="total, prev, pager, next"
                :disabled="isLoading">
            </el-pagination>
        </div>
        <AppPackDialog :is-show="isAppPackDialogShow" @close="isAppPackDialogShow = false"></AppPackDialog>
    </div>
</template>

<script>
import { GetAppList } from '@/request/api'
import AppPackDialog from './AppPackDialog.vue'
export default {
    name: "AppList",
    components: { AppPackDialog },
    data() {
        return {
            tableData: [],
            pagination: null,
            isLoading: false,
            tableHeight: 0,
            isAppPackDialogShow: false
        }
    },
    methods: {
        /**
         * 获取APP列表
         */
        getAppList() {
            const params = {}
            if (this.pagination) {
                params.page = this.pagination.curPage
            }
            this.isLoading = true
            GetAppList(params)
                .then(data => {
                    this.tableData = data.list
                    this.pagination = data.pagination
                    console.log('appList', this.tableData)
                    this.isLoading = false
                }).catch(error => {
                    console.log(error)
                    this.isLoading = false
                })
        },
        /**
         * 页码更改
         * */
        handleCurrentChange(page) {
            console.log('handleCurrentChange', page)
            this.pagination.curPage = page;
            this.getAppList();
        },
        /**
         * 可视化编辑
         */
        visualEdit(app) {
            const appID = app.appID
            console.log('appID', appID)
            let routeUrl = this.$router.resolve(
                {
                    path: "/visual/" + appID
                }
            );
            window.open(routeUrl.href, '_blank');
        },
        /**
         * 获取table的高度
         */
        getTableHeight() {
            return this.$refs['box'].offsetHeight - this.$refs['header'].offsetHeight - this.$refs['footer'].offsetHeight
        }
    },
    mounted() {
        this.getAppList(),
            this.$nextTick(() => {
                this.tableHeight = this.getTableHeight()
            })
    }
}
</script>

<style lang="less">
.list-box {
    overflow: hidden;
    height: 100%;

    .header {
        // height: 50%;
        padding: 15px;
    }

    .footer {
        height: 40px;
        padding-top: 4px;
        position: fixed;
        right: 15px;
    }

    .table {
        padding: 0 10px;
    }
}

.logo {
    width: 50px;
    height: 50px;
}
</style>